import { DomainEntity } from "../DomainEntity";
import { GeometricElement } from "../GeometricSurfaceElement";
import * as THREE from '@phdsoft/three';
import { Section } from "../Framework/Section";
import { ELEMENTSTYPESIDS } from "projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds";
export abstract class SectionElement extends GeometricElement {
    public SectionId: string;
    public SectionName: string;
    public sectionNormal: THREE.Vector3;
    public TypeId: ELEMENTSTYPESIDS;
    public abstract VerifyProperties(): any;

    public section: Section;

}